import React from 'react';

import { List } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';

import SortableItem from './SortableItem';
const SortableList = ({
    canUpdate = true,
    handleClickDelete,
    handleClickDuplicate,
    handleClickSelect,
    id,
    selectedPageId,
    onDragEnd,
    items,
    refDictionary,
    scrollDisabled,
}) => {
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId={id}>
                {(provided) => (
                    <List
                        className="sortable"
                        disablePadding
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {items.map((item, index) => (
                            <SortableItem
                                canUpdate={canUpdate}
                                handleClickDelete={handleClickDelete}
                                handleClickDuplicate={handleClickDuplicate}
                                handleClickSelect={handleClickSelect}
                                selectedPageId={selectedPageId}
                                index={index}
                                item={item}
                                key={`sortable-item-${item.id}`}
                                refDictionary={refDictionary}
                                scrollDisabled={scrollDisabled}
                            />
                        ))}
                    </List>
                )}
            </Droppable>
        </DragDropContext>
    );
};

SortableList.propTypes = {
    canUpdate: PropTypes.bool,
    handleClickDelete: PropTypes.func,
    handleClickDuplicate: PropTypes.func,
    handleClickSelect: PropTypes.func,
    id: PropTypes.string,
    selectedPageId: PropTypes.string,
    onDragEnd: PropTypes.func,
    items: PropTypes.array,
    refDictionary: PropTypes.object,
    scrollDisabled: PropTypes.bool,
};

export default SortableList;
